<button
    class="app-mobile-nav"
    app-button
    buttonType="primary"
    buttonShape="circle"
    buttonSize="large"
    buttonTheme="light"
    [matMenuTriggerFor]="mobileMenu">
    <fa-icon icon="bars"></fa-icon>
</button>

<mat-menu #mobileMenu="matMenu">
  <button
    class="menu__item"
    mat-menu-item 
    (click)="handleLogout()">
    Sign Out
  </button>

  <mat-divider></mat-divider>

  <button
    class="menu__item"
    mat-menu-item 
    (click)="handleHelpClicked()">
    Help
  </button>

  <mat-divider></mat-divider>

  <button
    class="menu__item"
    routerLink="/explore"
    mat-menu-item>
    Explore
  </button>

  <button
    class="menu__item"
    mat-menu-item
    routerLink="/dashboard">
    Dashboard
  </button>
</mat-menu>